import Vue from 'vue';

/**
 * Notify success and return the payload
 * @param {String} message
 */
export default function notifySuccess(message) {
  return (payload) => {
    Vue.toasted.success(message);
    return payload;
  };
}
